import React from "react";
import MCardContent from '@mui/material/CardContent';

const CardContent = (props) => {
  return <MCardContent {...props} />;
};

export default CardContent;